export let MakeChanges = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.451"
      height="23.386"
      viewBox="0 0 11.451 20.386"
    >
      <g
        id="Group_1765"
        data-name="Group 1765"
        transform="translate(-1392.845 -568.988)"
      >
        <path
          id="Path_1974"
          data-name="Path 1974"
          d="M1399.539,570.552l-6.577,8.7a.52.52,0,0,0-.1.31l-.013,3.81a.5.5,0,0,0,.2.414.493.493,0,0,0,.459.083l3.655-1.053a.507.507,0,0,0,.269-.184h0l6.576-8.7a1.417,1.417,0,0,0-.274-1.989l-2.2-1.666a1.41,1.41,0,0,0-.858-.289,1.486,1.486,0,0,0-.2.013A1.4,1.4,0,0,0,1399.539,570.552Zm-5.661,12.137.005-2.088,2,1.515Zm3.042-1.091-2.826-2.133,4.739-6.269,2.826,2.132Zm3.7-10.572a.4.4,0,0,1,.283.078l2.2,1.665a.382.382,0,0,1,.15.263.4.4,0,0,1-.078.282l-.9,1.192-2.826-2.132.906-1.2A.4.4,0,0,1,1400.621,571.027Z"
          transform="translate(0 -1)"
          fill="grey"
        />
        <rect
          id="Rectangle_100"
          data-name="Rectangle 100"
          width="10.808"
          height="1.033"
          transform="translate(1393.175 584.341)"
          fill="grey"
        />
      </g>
    </svg>
  );
};
